import { resetPassword } from '@jetshop/core/data/mutations/accountMutations.gql';
import t from '@jetshop/intl';
import { Form, Formik } from 'formik';
import React, { useContext } from 'react';
import { useMutation } from '@apollo/react-hooks';
import { Redirect, withRouter } from 'react-router';
import getErrorDetail from '../../helpers/getErrorDetail';
import throwErrorInDev from '../../helpers/throwErrorInDev';
import { createValidatorForFields } from './formFieldsFromSettings';
import { useCountrySettings } from '../ChannelContext/useCountrySettings';
function usePasswordValidation() {
    const { selectedCountrySettings } = useCountrySettings();
    const passwordField = selectedCountrySettings &&
        selectedCountrySettings.privateCustomerFields.find((field) => field.name === 'password');
    return createValidatorForFields([passwordField], {
        getFieldName: () => 'newPassword',
    });
}
// Context to hold formik state
const ResetPasswordContext = React.createContext(undefined);
export const ResetPasswordProvider = withRouter(function ResetPasswordProvider(props) {
    const params = props.match.params;
    const { token: resetPasswordToken } = params;
    const [resetPasswordMutation] = useMutation(resetPassword);
    const validator = usePasswordValidation();
    // We need a token to post with the password reset mutation
    if (!resetPasswordToken) {
        return React.createElement(Redirect, { to: "/" });
    }
    return (React.createElement(Formik, { initialValues: { newPassword: '' }, validate: validator, onSubmit: ({ newPassword }, actions) => {
            actions.setSubmitting(true);
            resetPasswordMutation({
                variables: {
                    newPassword,
                    resetPasswordToken,
                },
            })
                .then(() => {
                actions.setSubmitting(false);
                actions.setStatus('submitted');
            })
                .catch((err) => {
                actions.setSubmitting(false);
                actions.setStatus(getErrorDetail(err).codes);
            });
        } }, (formik) => (React.createElement(Form, null,
        React.createElement(ResetPasswordContext.Provider, Object.assign({}, props, { value: { formik } }))))));
});
// Hook that can be used to get the formik data, submit state, and translated error
export function useResetPasswordForm() {
    const context = useContext(ResetPasswordContext);
    throwErrorInDev(!context, '`useResetPassword` may only be called from within `ResetPasswordProvider`');
    const { formik } = context;
    // We only want to display one error, so grab the first
    const globalError = Array.isArray(formik.status)
        ? formik.status.map(getErrorMessage)[0]
        : undefined;
    const passwordInputProps = {
        required: true,
        type: 'password',
        name: 'newPassword',
        autoComplete: 'new-password',
    };
    return Object.assign(Object.assign({}, formik), { passwordInputProps, submitted: formik.status === 'submitted', globalError: globalError });
}
// Takes an error code from the API and converts to a friendly string
function getErrorMessage(code) {
    const errorTranslations = {
        InvalidResetPasswordToken: t('Your password reset token has expired, or is invalid.'),
    };
    if (errorTranslations[code])
        return errorTranslations[code];
    // Fallback
    return t('The form could not be submitted. Please try again later.');
}
//# sourceMappingURL=ResetPasswordProvider.js.map